import { useState } from "react";
import { MPEditContainerForm } from "./form";
import { useGetContainersQuery } from "../../services";

export const EditCustomPluginContainer = ({ idToEdit, handleClose, showForm }) => {
  //const { data: newContainers } = useGetContainersQuery();

  return <>{showForm && <MPEditContainerForm idToEdit={idToEdit} onClose={handleClose} />}</>;
};
